export default __webpack_public_path__ + "media/images/projekktor-maccaco/noise-00b229cbc005e9b67ecf552edfa01e7d.gif";